// Copyright (c) 2016 Deere & Company

const otherStatuses = [
    'NEW',
    'USED',
    'DMGD',
    'EOOS',
    'RMLN',
    'STLP',
    'STNR'
];

export default otherStatuses;



// WEBPACK FOOTER //
// ./src/product/status-change-request/utils/other-statuses.js